import classNames from 'classnames';
import React from 'react';

import { Theme } from '@insights-gaming/theme';
import { TableHead, TableRow } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import { LoLHelper } from '../../../utils';
import { StatisticsTableCell } from '../../StatisticsTableCell';

interface LeagueOfLegendsTableHeaderOwnProps {
  className?: string;
  isUserTeam: boolean;
  headers: string[];
}

type LeagueOfLegendsTableHeaderProps = LeagueOfLegendsTableHeaderOwnProps;

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    backgroundColor: ({ isUserTeam }: LeagueOfLegendsTableHeaderOwnProps) =>
    `${LoLHelper.getUserColor(theme, isUserTeam)}19`,
    borderColor: ({ isUserTeam }: LeagueOfLegendsTableHeaderOwnProps) => `${LoLHelper.getUserColor(theme, isUserTeam)}`,
    borderTop: '1px solid',
    borderBottom: '1px solid',
    '&:first-child': {
      borderLeftStyle: 'solid',
      borderLeftWidth: 1,
    },
    '&:last-child': {
      borderRightStyle: 'solid',
      borderRightWidth: 1,
    },
  },
}), {name: 'LeagueOfLegendsTableHeader'});

export function LeagueOfLegendsTableHeader(props: LeagueOfLegendsTableHeaderProps) {
  const classes = useStyles(props);
  const { className, headers } = props;
  return (
    <TableHead>
      <TableRow>
        {headers.map(h => (
          <StatisticsTableCell key={h} className={classNames(classes.root, className)}>
            {h}
          </StatisticsTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
